import React from "react";
import "./whytravel.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeadset,
  faStar,
  faHotel,
  faGlobe,
  faShieldAlt,
  faClock,
  faUsers,
  faMoneyBillWave
} from "@fortawesome/free-solid-svg-icons";

function Whydq() {
  return (
    <main>
         <div className="chitto">
        <div className="banner-contact">
          <img src="/img/company/partner.jpg" alt="help" />
          <div className="banner-contact-box"></div>
          <div className="contactus-header">
        <h1>We Work For You</h1>
        <p>Know This Businees Model In 8 Steps</p>
      </div>
      </div>
      </div>
    <div className="whychooseus-section">

      <div className="whychooseus-container">

        <div className="whychooseus-card">
          <FontAwesomeIcon icon={faHeadset} className="whychooseus-icon" />
          <h3>24/7 Human Support</h3>
          <p>We are always available to assist you anytime during your journey.</p>
        </div>

        <div className="whychooseus-card">
          <FontAwesomeIcon icon={faStar} className="whychooseus-icon" />
          <h3>Trusted Experience</h3>
          <p>Serving travelers for more than 8 years with top satisfaction.</p>
        </div>

        <div className="whychooseus-card">
          <FontAwesomeIcon icon={faHotel} className="whychooseus-icon" />
          <h3>All-in-One Booking</h3>
          <p>Hotels, flights, activities, guides and packages in one place.</p>
        </div>

        <div className="whychooseus-card">
          <FontAwesomeIcon icon={faGlobe} className="whychooseus-icon" />
          <h3>Global Reach</h3>
          <p>We connect you with destinations and experiences worldwide.</p>
        </div>

        <div className="whychooseus-card">
          <FontAwesomeIcon icon={faShieldAlt} className="whychooseus-icon" />
          <h3>Safe & Secure</h3>
          <p>Your bookings and data are protected with advanced security.</p>
        </div>

        <div className="whychooseus-card">
          <FontAwesomeIcon icon={faClock} className="whychooseus-icon" />
          <h3>Flexible Booking</h3>
          <p>Plan now and adjust later with easy rescheduling options.</p>
        </div>

        <div className="whychooseus-card">
          <FontAwesomeIcon icon={faUsers} className="whychooseus-icon" />
          <h3>Expert Guides</h3>
          <p>Professional and friendly guides for better travel experience.</p>
        </div>

        <div className="whychooseus-card">
          <FontAwesomeIcon icon={faMoneyBillWave} className="whychooseus-icon" />
          <h3>Best Price Guarantee</h3>
          <p>We offer competitive pricing with no hidden costs.</p>
        </div>

      </div>
    </div>
    </main>
  );
}

export default Whydq;